<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Animated Brochure</div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-75">
            <div class="component__columns-2 layout__margin-20-0">
                <div class="layout__padding-clear">
                    <video class="layout__width-90 layout__padding__bottom-25px" controls autoplay loop>
                        <source src="https://rpsassets.blob.core.windows.net/rpsimages/animated-brochure.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
            <div class="component__columns-2 layout__margin-20-0">
                <h3 class="text__colour-teal text__style-bold-900">An impressive company brochure matters, but it’s not
                    always easy to get a printed product into a client’s hands.</h3>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    A fully-animated digital brochure not only solves this problem, but it offers an opportunity to
                    really wow your clients with a more immersive brand experience.
                </div>

                <div class="text__size-16 text__colour-grey text__line-height-20px">
                    We offer a fully tailored design solution, so if you’re looking to go digital but don’t really know
                    how to get there, we can help you along the way. We make sure your output sits comfortably within
                    your brand handwriting and works as hard as possible for your business.
                </div>

                <div class="layout__padding-20-0">
                    <el-button class="layout__width-200px button-red"
                               v-on:click="contactUs()">Find out more
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                You may also like
            </div>


            <div class="layout__width-80 layout__padding-clear">

                <router-link class="link__colour-black" to="/products/digital/motion-graphics">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/motion-graphics.png"
                             class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Motion Graphics</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/digital-window-cards">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/digiwindowcard.png"
                             class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Digital Window Cards</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/email-signature">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/email-sig-720x500.png"
                             class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Email Signatures</div>
                        </div>
                    </div>
                </router-link>

            </div>
        </div>


    </div>

</template>

<script>

    import Router from '../../../router';

    export default {
        name: "AB",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            }
        }
    };
</script>